/*============================================================================
  APP-CORE.js - Essential global functionality
  Loaded on ALL pages (defer)
  Contains: Header, navigation, cart basics, utilities, third-party libs
=============================================================================*/

/*============================================================================
  Third-party libraries (these are also in app.js.liquid but required for core functionality)
=============================================================================*/

/*! Zoom 1.7.21 license: MIT http://www.jacklmoore.com/zoom */
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(a):!1)}function n(){r.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(a):!1)}var f=o.zoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.setAttribute("role","presentation"),a.alt="",a.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);

/*! js-url - v2.5.3 - 2018-04-05 */
!function(){var a=function(){function a(){}function b(a){return decodeURIComponent(a.replace(/\+/g," "))}function c(a,b){var c=a.charAt(0),d=b.split(c);return c===a?d:(a=parseInt(a.substring(1),10),d[a<0?d.length+a:a-1])}function d(a,c){for(var d=a.charAt(0),e=c.split("&"),f=[],g={},h=[],i=a.substring(1),j=0,k=e.length;j<k;j++)if(f=e[j].match(/(.*?)=(.*)/),f||(f=[e[j],e[j],""]),""!==f[1].replace(/\s/g,"")){if(f[2]=b(f[2]||""),i===f[1])return f[2];h=f[1].match(/(.*)\[([0-9]+)\]/),h?(g[h[1]]=g[h[1]]||[],g[h[1]][h[2]]=f[2]):g[f[1]]=f[2]}return d===a?g:g[i]}return function(b,e){var f,g={};if("tld?"===b)return a();if(e=e||window.location.toString(),!b)return e;if(b=b.toString(),f=e.match(/^mailto:([^\/].+)/))g.protocol="mailto",g.email=f[1];else{if((f=e.match(/(.*?)\/#\!(.*)/))&&(e=f[1]+f[2]),(f=e.match(/(.*?)#(.*)/))&&(g.hash=f[2],e=f[1]),g.hash&&b.match(/^#/))return d(b,g.hash);if((f=e.match(/(.*?)\?(.*)/))&&(g.query=f[2],e=f[1]),g.query&&b.match(/^\?/))return d(b,g.query);if((f=e.match(/(.*?)\:?\/\/(.*)/))&&(g.protocol=f[1].toLowerCase(),e=f[2]),(f=e.match(/(.*?)(\/.*)/))&&(g.path=f[2],e=f[1]),g.path=(g.path||"").replace(/^([^\/])/,"/$1"),b.match(/^[\-0-9]+$/)&&(b=b.replace(/^([^\/])/,"/$1")),b.match(/^\//))return c(b,g.path.substring(1));if(f=c("/-1",g.path.substring(1)),f&&(f=f.match(/(.*?)\.([^.]+)$/))&&(g.file=f[0],g.filename=f[1],g.fileext=f[2]),(f=e.match(/(.*)\:([0-9]+)$/))&&(g.port=f[2],e=f[1]),(f=e.match(/(.*?)@(.*)/))&&(g.auth=f[1],e=f[2]),g.auth&&(f=g.auth.match(/(.*)\:(.*)/),g.user=f?f[1]:g.auth,g.pass=f?f[2]:void 0),g.hostname=e.toLowerCase(),"."===b.charAt(0))return c(b,g.hostname);a()&&(f=g.hostname.match(a()),f&&(g.tld=f[3],g.domain=f[2]?f[2]+"."+f[3]:void 0,g.sub=f[1]||void 0)),g.port=g.port||("https"===g.protocol?"443":"80"),g.protocol=g.protocol||("443"===g.port?"https":"http")}return b in g?g[b]:"{}"===b?g:void 0}}();"function"==typeof window.define&&window.define.amd?window.define("js-url",[],function(){return a}):window.url=a}();

/*============================================================================
  Plyr Utilities (needed globally for video player)
=============================================================================*/
var plyrUtils = {
  playButtonIcon:'<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
};

var controls = plyrUtils.playButtonIcon + '<div class="plyr__controls">' + plyrUtils.playButton + plyrUtils.progressInput + plyrUtils.muteButton + plyrUtils.volume + plyrUtils.fullscreen + '</div>';
var globalPlayersArray = [];
var secondaryMediaPlayers;

/*============================================================================
  Responsive media
=============================================================================*/
function enableResponsiveVideoWrapper() {
  // Wrap third-party embeds unless Plyr already generated the wrapper markup.
  $('iframe[src*="youtube.com"]').not('.plyr__video-wrapper iframe[src*="youtube.com"]').wrap('<div class="plyr__video-embed"></div>');
  $('iframe[src*="vimeo.com"]').not('.plyr__video-wrapper iframe[src*="vimeo.com"]').wrap('<div class="plyr__video-embed"></div>');
}

/*============================================================================
  Global - header
=============================================================================*/
var header = {
  navMenu: null,
  navDrawer: null,
  cartMenu: null,
  cartDrawer: null,
  navTitleObserver: null,
  init: function(){
    this.setHeaderPosition();

    if ($('.mobile-header').length > 1) {
      $('.mobile-header:last, #nav:last, #cart:last').remove();
    }

    var $header = $('.feature_image .header.header-background--false');

    if ($('.header').hasClass('mm-fixed-top')) {
      $('.menu li:not(.cart) a[href^="#"], .flex-caption a[href^="#"]').on('click', function(e) {
        var anchorlink = $(this).attr('href');
        if($('.index-sections').find(anchorlink).length) {
          e.preventDefault();
          var headerHeight = $('.header').outerHeight();
          $('html, body').animate({
            scrollTop: $(anchorlink).offset().top - headerHeight
          }, 2000)
        }
      })
    };

    if ($header.hasClass('sticky-header--true')) {
      header.initStickyHeader($header);
    }

    $header.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', function() {
      $(this).removeClass('fadeIn');
    });

    $('.cart-button, .icon-menu').on("click", function(e) {
      $('#search').hide();
    });
    this.initMobileDrawers();

    $('body').on('mouseover', '.sub-menu', function() {
      $(this).attr('aria-expanded', true);
    });
    $('body').on('mouseout', '.sub-menu', function() {
      $(this).attr('aria-expanded', false);
    });

    this.dynamicDropdown();
  },
  initMobileDrawers: function() {
    if (typeof MmenuLight === 'undefined' || this.navDrawer || this.cartDrawer) {
      return;
    }

    var nav = document.getElementById('nav');
    var cart = document.getElementById('cart');

    if (!nav || !cart) {
      return;
    }

    var menuTheme = nav.classList.contains('mobile-menu-color--white') ? 'light' : 'dark';
    var menuTitle = (Shopify.translation && Shopify.translation.menu) ? Shopify.translation.menu : 'Menu';

    this.navMenu = new MmenuLight(nav, 'all');
    this.navMenu.navigation({
      title: menuTitle,
      selectedClass: 'Selected',
      slidingSubmenus: true,
      theme: menuTheme
    });
    this.navDrawer = this.navMenu.offcanvas({
      position: 'left'
    });
    this.navDrawer.wrapper.classList.add('theme-mmenu-light-wrapper', 'theme-mmenu-light-wrapper--nav');
    this.decorateNavDrawer(nav);

    this.cartMenu = new MmenuLight(cart, 'all');
    this.cartDrawer = this.cartMenu.offcanvas({
      position: 'right'
    });
    this.cartDrawer.wrapper.classList.add('theme-mmenu-light-wrapper', 'theme-mmenu-light-wrapper--cart');

    if (cart.classList.contains('side-cart-position--bottom')) {
      this.cartDrawer.wrapper.classList.remove('mm-ocd--right');
      this.cartDrawer.wrapper.classList.add('mm-ocd--bottom');
    }

    $(document).off('.themeMobileDrawer');
    $(document).on('click.themeMobileDrawer', 'a[href="#nav"], .icon-menu[href="#nav"]', function(e) {
      e.preventDefault();
      header.navDrawer.open();
    });
    $(document).on('click.themeMobileDrawer', 'a[href="#cart"].cart-button, .cart-button[href="#cart"]', function(e) {
      e.preventDefault();
      header.cartDrawer.open();
    });
    $(document).on('click.themeMobileDrawer', '#cart .continue', function(e) {
      e.preventDefault();
      if (header.cartDrawer) {
        header.cartDrawer.close();
      }
    });
  },
  decorateNavDrawer: function(nav) {
    if (!this.navDrawer) {
      return;
    }

    var $mobileLogo = $('.mobile_logo').first();
    var logoMarkup = $mobileLogo.length ? $mobileLogo.html() : '';
    var siteName = $mobileLogo.attr('title') || document.title || 'Menu';
    var titleLink = document.createElement('a');

    titleLink.className = 'mmenu-light__title';
    titleLink.href = '/';
    titleLink.setAttribute('aria-label', siteName);

    this.navDrawer.content.classList.add('theme-mmenu-light-content');
    this.navDrawer.content.insertBefore(titleLink, nav);

    var updateTitle = function() {
      var panelTitle = nav.getAttribute('data-mm-spn-title') || '';
      var isMainPanel = nav.classList.contains('mm-spn--main');

      if (isMainPanel || !panelTitle || panelTitle === 'Menu') {
        titleLink.classList.remove('mmenu-light__title--text');
        titleLink.innerHTML = logoMarkup || '<span>' + siteName + '</span>';
        return;
      }

      titleLink.classList.add('mmenu-light__title--text');
      titleLink.textContent = panelTitle;
    };

    if (this.navTitleObserver) {
      this.navTitleObserver.disconnect();
    }

    this.navTitleObserver = new MutationObserver(updateTitle);
    this.navTitleObserver.observe(nav, {
      attributes: true,
      attributeFilter: ['class', 'data-mm-spn-title']
    });

    updateTitle();
  },
  initStickyHeader: function($header) {
    var $trigger = $(".index-sections .shopify-section:nth-child(2), .shopify-section:nth-child(2), .main-wrapper, .page-details-block:nth-child(2)").first();

    $(window).off('.stickyHeader');

    if (!$trigger.length) {
      return;
    }

    function updateStickyState() {
      var triggerTop = $trigger.offset().top - $header.outerHeight() - 250;
      var isSticky = $(window).scrollTop() >= triggerTop;

      if (isSticky) {
        $header.addClass('sticky--active fadeInDown delay-0s header_bar');
        $header.removeClass('is-absolute');
      } else {
        $header.removeClass('sticky--active fadeInDown delay-0s header_bar');
        $header.addClass('is-absolute');
      }

      header.dynamicDropdown();
    }

    $(window).on('scroll.stickyHeader resize.stickyHeader load.stickyHeader', updateStickyState);
    updateStickyState();
  },
  setHeaderPosition: function() {
    if ($('.promo-banner').length) {
      var announcementHeight = $('.promo-banner').outerHeight();
      $('.header').css('top', announcementHeight);
    } else {
      $('.header').css('top', '0');
    }
  },
  dynamicDropdown: function() {
    var headerNavigationWidth = $('[data-header-navigation]').width();
    var $headerNavItems = $('[data-header-nav-item]');
    var dropdownPosition = $('.header').data('dropdown-position');
    var singleLineNav = true;
    var totalNavItemsWidth = 0;

    $headerNavItems.each(function(index, navItem){
      totalNavItemsWidth += $(navItem).outerWidth();
    })

    if (totalNavItemsWidth > headerNavigationWidth) {
      singleLineNav = false;
    }

    if (dropdownPosition == 'below_header' && singleLineNav == true) {
      $('.header_bar').removeClass('header-dropdown-position--below_parent');
      $('.header_bar').addClass('header-dropdown-position--below_header');
      $('.header_bar').attr('data-dropdown-position', 'below_header');
      $('.header_bar.header-dropdown-position--below_header .dropdown').css({ "padding-top": $('.header').height() / 2 });
      $('.header_bar.header-dropdown-position--below_header .disclosure__list-wrap').css({ "padding-top": $('.header').height() / 2 });
    } else {
      $('.header').addClass('header-dropdown-position--below_parent');
      $('.header').removeClass('header-dropdown-position--below_header');
      $('.header').attr('data-dropdown-position', 'below_parent');
      $('.header .dropdown').removeAttr('style');
    }
  },
  setPadding: function() {
    if ($('body').hasClass('index') && Shopify.media_queries.large.matches || $('.shopify-section.shopify-section--page-details-template').length && Shopify.media_queries.large.matches) {
      var $reorderableFirstSection = $('.index-sections .shopify-section, .shopify-section--page-details-template .page-details-block').first();
      if ($reorderableFirstSection.hasClass('parallax-banner')) {
        if ($('.header').hasClass('header-background--true') && $('.header').hasClass('header-transparency--false')){
          $reorderableFirstSection.css('padding-top', $('.header').height());
        }
      }
    }
  },
  openDropdown: function() {
    var $menuItems = $('.sub-menu');
    $.each($menuItems, function(index, menuItem) {
      $(menuItem).on('keydown', function(e) {
        var itemVisited;
        if ($(this).hasClass('show-dropdown')) {
          var itemVisited = true;
        } else {
          var itemVisited = false;
        }
        if (e.which === 13) {
          if (itemVisited === false) {
            e.preventDefault();
          }
          $(this).addClass('show-dropdown');
          itemVisited = true;
        }
      })
      $(menuItem).on('focusout', function(e) {
        if($(this).find(e.relatedTarget).length === 0) {
          $(menuItem).removeClass('show-dropdown');
        }
      })
    })
  },
  unload: function($target){
    $('a[href^="#"]').off('click');
    $(window).off('.stickyHeader');
  }
}

/*============================================================================
  Home page - featured promotions
=============================================================================*/
var featured_promotions = {
  init: function(){
    animate_content.init();
  },
  unload: function($target){}
}

/*============================================================================
  Banner image
=============================================================================*/
var banner_image = {
  init: function(){
    if (Shopify.media_queries.large.matches) {
      if ($('body').hasClass('index') || $('.shopify-section.shopify-section--page-details-template').length){
        var $reorderableFirstSection = $('.index-sections .shopify-section, .shopify-section--page-details-template .page-details-block').first();
        $reorderableFirstSection.attr('style', '');

        if ($reorderableFirstSection.hasClass('parallax-banner')) {
          if ($('.header').hasClass('header-background--true') && $('.header').hasClass('header-transparency--false')){
            $reorderableFirstSection.css('padding-top', $('.header').height());
            $('.header').parent().removeClass('feature_image');
            $('.header').addClass('header_bar');
            if ($('.header').hasClass('sticky-header--false')){
              $('.header').addClass('is-absolute');
            } else {
              $('.header.is-absolute').removeClass('is-absolute');
            }
          } else if ($('.header').hasClass('header-background--false') && $('.header').hasClass('header-transparency--true')){
            $('.header').parent().addClass('feature_image');
            $('.header').removeClass('header_bar');
            $('.header').addClass('is-absolute');
            if ($('.header').hasClass('sticky-header--true')){
              $('.header').addClass('is-absolute');
            }
          } else if ($('.header').hasClass('header-background--false') && $('.header').hasClass('header-transparency--false')){
            $('.header').parent().addClass('feature_image');
            $('.header').removeClass('header_bar');
            $('.header').addClass('is-absolute');
            if ($('.header').hasClass('sticky-header--true')){
              $('.header').addClass('is-absolute');
            }
          } else if ($('.header').hasClass('header-background--true') && $('.header').hasClass('header-transparency--true')){
            $('.header').parent().removeClass('feature_image');
            $('.header').addClass('header_bar');
            if ($('.header').hasClass('sticky-header--false')){
              $('.header').addClass('is-absolute');
            } else {
              $('.header.is-absolute').removeClass('is-absolute');
            }
          }
        } else {
          $reorderableFirstSection.css('padding-top', $('.header').height());
          if ($('.header').hasClass('sticky-header--false')){
            $('.header').addClass('header_bar');
            $('.header').addClass('is-absolute');
          } else {
            $('.feature_image').removeClass('feature_image');
            $('.header').addClass('header_bar');
            $('.header.is-absolute').removeClass('is-absolute');
          }
        }
      } else {
        var $staticFirstSection = $('.global-wrapper .shopify-section').first();
        if ($staticFirstSection.children().first().hasClass('featured-image--true')) {
          if ($('.header').hasClass('header-background--true')){
            $('.header').parent().addClass('feature_image');
            $('.header').addClass('header_bar');
          } else if ($('.header').hasClass('header-background--false')) {
            $('.header').parent().addClass('feature_image');
            $('.header').removeClass('header_bar');
          }
          if ($('.header').hasClass('header-transparency--false') && $('.header').hasClass('header-background--true')){
            $staticFirstSection.css('padding-top', $('.header').height());
          }
        } else {
          if ($('.header').hasClass('sticky-header--false')){
            $('.header').addClass('header_bar');
            $('.header').addClass('is-absolute');
          } else {
            $('.feature_image').removeClass('feature_image');
            $('.header').addClass('header_bar');
            $('.header.is-absolute').removeClass('is-absolute');
          }
        }
      }
    }
  },
  resetPadding: function () {
    var $reorderableFirstSection = $('.index-sections .shopify-section, .shopify-section--page-details-template .page-details-block').first();
    if ($reorderableFirstSection.hasClass('parallax-banner')) {
      $reorderableFirstSection.css('padding-top', '0px');
    } else {
      if (Shopify.media_queries.large.matches) {
        $reorderableFirstSection.css('padding-top', $('.header').height());
      } else {
        $reorderableFirstSection.css('padding-top', '0px');
      }
    }
  },
  unload: function($target){}
}

/*============================================================================
  Announcement Bar
=============================================================================*/
var announcement_bar = {
  init: function() {
    if ($('.promo-banner').length) {
      var canUseCookies = typeof Cookies !== 'undefined' && Cookies && typeof Cookies.get === 'function' && typeof Cookies.set === 'function';
      var announcement = canUseCookies ? Cookies.get('promo-banner') : null;
      if(announcement != 'dismiss') {
        $('body').addClass('promo-banner--true');
        $('.promo-banner__close').on('click', function(){
          $('.promo-banner--true').attr('style', '');
          $('body').removeClass('promo-banner--true');
          announcement_bar.setPadding();
          if (canUseCookies) {
            Cookies.set('promo-banner', 'dismiss', { path: '/', expires: 30 });
          }
        });
      } else {
        $('body').removeClass('promo-banner--true');
      }
    } else {
      $('body').removeClass('promo-banner--true');
    }
    announcement_bar.setPadding();
  },
  setPadding: function() {
    var bannerHeight = $('.promo-banner').innerHeight();
    var bannerPadding = (bannerHeight - 25) + 'px';
    var parentSection = $('.promo-banner').parent('.shopify-section--header');
    if ($('body').hasClass('promo-banner--true')) {
      if ($('.header').hasClass('sticky-header--true') || $('.mobile-header').hasClass('mobile-sticky-header--false') && Shopify.media_queries.medium.matches) {
        $(parentSection).css('padding-bottom', bannerPadding);
      }
    } else {
      $(parentSection).css('padding-bottom', '0');
      $('.header').css('top', '0');
    }
  }
}

/*============================================================================
  Banner
=============================================================================*/
var banner = {
  bindScrollArrows: function(offset) {
    $('.scroll-arrow')
      .off('click.bannerScroll')
      .on('click.bannerScroll', function(event) {
        var targetSelector = $(this).attr('href');

        if (!targetSelector || targetSelector.charAt(0) !== '#') {
          return;
        }

        var target = document.querySelector(targetSelector);

        if (!target) {
          return;
        }

        event.preventDefault();

        var top = target.getBoundingClientRect().top + window.pageYOffset - (offset || 0);

        window.scrollTo({
          top: Math.max(top, 0),
          behavior: 'smooth'
        });
      });
  },
  init: function(){
    animate_content.init();
    var headerHeight = $('.header').outerHeight();
    if ($('.header').hasClass('sticky-header--true')) {
      banner.bindScrollArrows(headerHeight);
    } else {
      banner.bindScrollArrows(0);
    }
    announcement_bar.init();
  },
  unload: function($target){}
}

/*============================================================================
  Utilities
=============================================================================*/
var utilities = {
  plyrPromise: null,
  listenForResize: function() {
    window.addEventListener('orientationchange', function ( event ) {
      setTimeout(function() {
        banner.init();
      }, 100);
    });

    var resizeTimeout;
    window.addEventListener('resize', function ( event ) {
      if ( !resizeTimeout ) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          announcement_bar.setPadding();
          animate_content.init();
          header.setHeaderPosition();
          banner_image.resetPadding();
          banner.init();
          header.dynamicDropdown();
          header.setPadding();
        }, 66);
      }
    }, false);
  },
  loadPlyr: function() {
    if (typeof Plyr !== 'undefined') {
      return Promise.resolve(Plyr);
    }

    if (utilities.plyrPromise) {
      return utilities.plyrPromise;
    }

    if (!window.__plyrAssetUrl) {
      return Promise.reject(new Error('Plyr asset URL is not available'));
    }

    utilities.plyrPromise = new Promise(function(resolve, reject) {
      var existingScript = document.querySelector('script[data-theme-asset="vendor-plyr"]');

      if (existingScript) {
        if (window.Plyr) {
          resolve(window.Plyr);
          return;
        }

        existingScript.addEventListener('load', function() {
          resolve(window.Plyr);
        }, { once: true });
        existingScript.addEventListener('error', function(error) {
          reject(error);
        }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = window.__plyrAssetUrl;
      script.defer = true;
      script.dataset.themeAsset = 'vendor-plyr';
      script.onload = function() {
        resolve(window.Plyr);
      };
      script.onerror = function(error) {
        reject(error);
      };
      document.head.appendChild(script);
    }).catch(function(error) {
      utilities.plyrPromise = null;
      throw error;
    });

    return utilities.plyrPromise;
  },
  launchVideoPlayer: function(Plyr, galleryObject, videos, showSecondaryMedia) {
    if (galleryObject != null) {
      galleryObject.videoPlayers = Plyr.setup(videos, {
        controls: controls,
        fullscreen: { enabled: true, fallback: true, iosNative: true },
        storage: { enabled: false }
      });

      $.each(galleryObject.videoPlayers, function(index, player) {
        globalPlayersArray.push(player);
      });
    } else if (showSecondaryMedia == true) {
      secondaryMediaPlayers = Plyr.setup(videos, {
        controls: controls,
        fullscreen: { enabled: true, fallback: true, iosNative: true },
        storage: { enabled: false }
      })

      $('.shopify-section--recommended-products').find('.products').attr('data-plyr-loaded', 'true');

      $.each(secondaryMediaPlayers, function(index, player) {
        globalPlayersArray.push(player);
      })

      $.each(globalPlayersArray, function(index, player) {
        var source = player.provider;
        var id = player.id;
        var $video;
        if (source == 'html5') {
          $video = $(player.elements.wrapper).find('video');
          $video.attr('data-plyr-video-id', id);
        }
      })

      return secondaryMediaPlayers;
    }
  },
  enableDisclosure: function() {
    var $disclosure = $('[data-disclosure]');
    var $toggle = $('[data-disclosure-toggle]');
    var $disclosureWrap = $('.disclosure__list-wrap');

    function checkOffScreen($openedToggle) {
      if($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }

    function closeDisclosures(ignoreTarget, currentTarget) {
      if(ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }
      $disclosureWrap.removeClass('disclosure--left');
    }

    $('body').on('keyup', function(e) {
      if(e.which == '27') {
        closeDisclosures();
      }
    });

    $disclosure.on('mouseleave', function(e) {
      closeDisclosures();
    });

    $toggle.on('mouseenter focus', function(e) {
      closeDisclosures(true, this);
      var $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    });

    $toggle.on('touchstart', function(e) {
      if (Shopify.media_queries.medium.matches || !Shopify.device.hasTouch.matches) {
        var $target = $(e.currentTarget);
        closeDisclosures(true, this);
        if(!$target.hasClass('is-clicked')) {
          $target.attr('aria-expanded', 'true').addClass('is-clicked');
          checkOffScreen($target);
        } else {
          $target.attr('aria-expanded', 'false').removeClass('is-clicked');
          $disclosureWrap.removeClass('disclosure--left');
        }
      }
    })
  },
  addImageDimension: function(imageUrl, size) {
    var insertPosition = imageUrl.lastIndexOf(".");
    return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
  },
  unload: function() {
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
    $('.disclosure__list-wrap').off();
  }
}

var toggleSidebarBlocks = function($toggle){
  if($toggle.next('ul').is(':visible')) {
    $toggle.next('ul').hide();
    $toggle.children('span').html('+');
    $toggle.attr('aria-expanded', false);
  } else {
    $toggle.next('ul').show();
    $toggle.children('span').html('-');
    $toggle.attr('aria-expanded', true);
  }
}

var toggleSidebarMenus = function($toggle){
  var $content = $toggle.next('ul');
  $content.slideToggle();
  $toggle.toggleClass('active');
  $toggle.attr('aria-expanded', $toggle.attr('aria-expanded') == 'true' ? 'false' : 'true');
}

var animate_content = {
  observer: null,
  init: function() {
    if (Shopify.media_queries.large.matches || $(window).width() == 0) {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      var animationMap = {
        animate_right: 'fadeInRight',
        animate_left: 'fadeInLeft',
        animate_up: 'fadeInUp',
        animate_in: 'fadeIn',
        animate_down: 'fadeInDown'
      };

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) {
              return;
            }

            var element = entry.target;

            Object.keys(animationMap).forEach(function(className) {
              if (element.classList.contains(className)) {
                element.classList.add('animated', animationMap[className]);
              }
            });

            observer.unobserve(element);
          });
        }, {
          rootMargin: '0px 0px -20% 0px'
        });

        Object.keys(animationMap).forEach(function(className) {
          $('.' + className).each(function() {
            animate_content.observer.observe(this);
          });
        });
      } else {
        $.each(animationMap, function(className, animationClass) {
          $('.' + className).addClass('animated ' + animationClass);
        });
      }
    }
  }
}

/*============================================================================
  Cart
=============================================================================*/
var cart = {
  init: function(){
    $("#address_country").val($("#address_country").data("default")).change();
  },
  unload: function(){}
}

/*============================================================================
  Currency Converter
=============================================================================*/
var currencyConverter = {
  init: function() {
    if (typeof Currency === 'undefined' || !Currency || typeof Currency.set !== 'function') {
      return;
    }

    $('#currency-converter').on('change', function() {
      Currency.set($(this).val());
      $(this).parents('[data-disclosure]').find('[data-disclosure-toggle] .disclosure-text').text($(this).find(':selected').text());
    });
  }
}

/*============================================================================
  Document Ready - Core initialization
=============================================================================*/
$(function() {
  utilities.listenForResize();
  utilities.enableDisclosure();

  window.lazySizesConfig = window.lazySizesConfig || {};
  lazySizesConfig.expand = 300;
  lazySizesConfig.loadHidden = false;

  $("body").on("click", '.continue', function() {
    if (header.cartDrawer && typeof header.cartDrawer.close === 'function') {
      header.cartDrawer.close();
    }
    if (header.navDrawer && typeof header.navDrawer.close === 'function') {
      header.navDrawer.close();
    }
  });

  $('.search-form .submit-search').on('click', function() {
    $(this).parents('form').submit();
  });

  $('.sub-menu').on('mouseenter', function(){
    if($(this).find('.dropdown').is(':off-right')) {
      $(this).find('.dropdown').addClass("dropdown--align");
    }
  });
  $('.sub-menu').on('mouseleave', function(){
    if($(this).find('.dropdown').hasClass('dropdown--align')) {
      $(this).find('.dropdown').removeClass("dropdown--align");
    }
  });

  header.openDropdown();

  var allPanels = $('.accordion > dd');
  for (var i = 0; i < allPanels.length; i++) {
    $(allPanels[i]).css('height', $(allPanels[i]).outerHeight());
  }
  allPanels.hide();

  $('.accordion > dt > a').click(function() {
    if(!$(this).parent().next().is(':visible')) {
      allPanels.slideUp();
      $(this).parent().next().slideDown();
      $('.accordion small.right').html('&#9668;');
      $(this).find('small.right').html('&#9660;');
    }
    return false;
  });
  $('.accordion dd:first-of-type').show();

  banner_image.init();
  header.init();
  banner.init();
  cart.init();
  featured_promotions.init();
  animate_content.init();

  if (Shopify.theme_settings.enable_autocomplete) {
    if (typeof searchAutocomplete !== 'undefined') {
      searchAutocomplete.init();
    }
  }

  var $jsSections = $('.shopify-section[class*=js]');
  var $jsSectionNames = $jsSections.each(function () {
    for (var i = 0; i < this.classList.length; i++) {
      if (this.classList[i].substring(0, 2) === "js"){
        var triggerClass = this.classList[i];
        if (Shopify.theme[triggerClass]) {
          Shopify.theme[triggerClass].init($(this));
        }
      }
    }
  });

  if (Currency.native_multi_currency && Currency.shipping_calculator) {
    currencyConverter.init();
  }

  enableResponsiveVideoWrapper();

  var $header = $(".feature_image .header");
  $(document).on('click', '.search__submit', function(e) {
    $(this).parent('form').submit();
  });

  $(document).on('click', '#search-toggle, .search__close', function(e) {
    e.stopPropagation();
    e.preventDefault();
    $('.search__form').css('padding-top', $('.header').height() + 50 + 'px');
    if($('#search').is(":visible") && $(window).scrollTop() == 0) {
      
    } else {
      $header.addClass('header-background--true');
    }
    if($('#search').hasClass("fadeIn")) {
      $('#search').removeClass("fadeIn").hide();
    } else {
      $('#search').show().addClass("fadeIn").find('input').focus();
    }
    $(document).off('click.searchDismiss').on('click.searchDismiss', function(e) {
      var searchForm = $(e.target).parents('.search__form');
      if(searchForm.length === 0) {
        $('#search').removeClass("fadeIn").hide();
        $(document).off('click.searchDismiss');
      }
    });
  });

  $(document).on('click', '.add', function() {
    var $count = $(this).closest('.wrap').find('.count');
    $count.val(+$count.val() + 1);
  });

  $(document).on('click', '.sub', function() {
    var $count = $(this).closest('.wrap').find('.count');
    if (+$count.val() > 1) {
      $count.val(+$count.val() - 1);
    }
  });

  $(document).on('click', '.accordion_head', function() {
    $('.accordian-block').removeClass('active-acc');
    $(this).parents('.accordian-block').addClass('active-acc');

    if ($('.accordion_body').is(':visible')) {
      $('.accordion_body').slideUp(300);
      $('.plusminus').text('+');
    }

    if ($(this).next('.accordion_body').is(':visible')) {
      $(this).next('.accordion_body').slideUp(300);
      $(this).children('.plusminus').text('+');
    } else {
      $(this).next('.accordion_body').slideDown(300);
      $(this).children('.plusminus').text('-');
    }
  });

  if ($.fn.flickity && window.Flickity) {
    $('.slider, .flexslider:not(.homepage_slider)').find('li').unwrap();
    $('.slider, .flexslider:not(.homepage_slider)').flickity({
      pageDots: false,
      autoPlay: 6000,
      imagesLoaded: true,
      lazyLoad: 2,
    });

    var arrowShape = '<svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.46 24.09"><title>flickity-arrow</title><polygon points="1.41 24.09 0 22.68 10.63 12.05 0 1.41 1.41 0 13.46 12.05 1.41 24.09"/></svg>';
    $('.slider, .flexslider').find('.flickity-prev-next-button.next .flickity-button-icon').replaceWith(arrowShape);
    $('.slider, .flexslider').find('.flickity-prev-next-button.previous').addClass('arrow-is-inverse').find('.flickity-button-icon').replaceWith(arrowShape);
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches == false && $.fancybox) {
    $.fancybox.defaults.animationEffect = 'fade';
    $.fancybox.defaults.transitionEffect = 'slide';
    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.infobar = false;
    $.fancybox.defaults.toolbar = false;
    $.fancybox.defaults.arrows = false;
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.smallBtn = true;
    $.fancybox.defaults.wheel = false;
    $.fancybox.defaults.live = false;
    $.fancybox.defaults.zoom = false;
    $.fancybox.defaults.btnTpl['smallBtn'] = '<a title="Close" data-fancybox-close class="fancybox-item fancybox-close ss-icon" href="javascript:;"></a>';
    $.fancybox.defaults.mobile.preventCaptionOverlap = false;
    $.fancybox.defaults.mobile.toolbar = true;
    $.fancybox.defaults.mobile.buttons = ['close'];
    $.fancybox.defaults.mobile.clickSlide = 'close';
    $.fancybox.defaults.mobile.clickContent = 'zoom';
    $.fancybox.defaults.afterLoad = function(instance, slide) {
      if (instance.current.type == 'image'){
        slide.$content.wrapInner( "<div class='fancybox-image-wrap'></div>" )
      }
      if (instance.group.length > 1){
        slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev ss-icon" href="javascript:;" data-fancybox-prev><span class="icon-circle-left"></span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next ss-icon" href="javascript:;" data-fancybox-next><span class="icon-circle-right"></span></a>')
      }
    }
    $('.lightbox').fancybox();
    $('[rel="gallery"]').fancybox({
      baseClass: "gallery-section__lightbox",
      clickContent: "nextOrClose"
    });
  }

  if (Shopify.theme_settings.newsletter_popup) {
    if (typeof newsletter_popup !== 'undefined') {
      newsletter_popup.init();
    }
  }

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

  $(document).on('click', '.menu-toggle', function(e) {
    toggleSidebarMenus($(this));
  });

  var sidebarTouched = false;
  $(document).on('touchstart', '.toggle', function(e) {
    if (Shopify.media_queries.medium.matches || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
      var $toggle = $(this);
      toggleSidebarBlocks($toggle);
      sidebarTouched = true;
      e.preventDefault();
      return false;
    }
  });
  $(document).on('click', '.toggle', function(e) {
    if (Shopify.media_queries.medium.matches || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
      var $toggle = $(this);
      if (!sidebarTouched) {
        toggleSidebarBlocks($toggle);
        e.preventDefault();
        return false;
      }
    }
  });

  if ($("#contact_form").length) {
    var contactFormResponse = url('?customer_posted');
    if (contactFormResponse){
      $('html,body').animate({
        scrollTop: $("#contact_form").offset().top
      });
    }
  }

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion && $.fn.flexslider) {
    $('.flexslider').flexslider('pause');
  }
});

selectCallback = function(variant, selector) {
  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form', $product);
  var variantInventory = $productForm.data('variant-inventory');

  var $notifyFormInputs = $('.notify_form__inputs');
  var notifyEmail = "Email address";
  var notifyEmailValue = "";
  var notifySend = "Send";

  if(variant) {
    if(variant.name != null) {
      var notifyMessage = $notifyFormInputs.data('notify-message') + ' - ' + variant.name;
    } else {
      var notifyMessage = $notifyFormInputs.data('notify-message');
    }
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    var notifyCustomerEmail = $notifyFormInputs.data('customer-email');
    var notifyEmailInput = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" value="'+ htmlEncode(notifyCustomerEmail || '') +'" />'
  } else {
    var notifyEmailInput = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="'+ htmlEncode(notifyEmail || '') +'" value="'+ htmlEncode(notifyEmailValue || '') +'" />';
  }
  var notifyFormHTML = notifyEmailInput+'<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="'+ notifyMessage +'" value="'+ notifyMessage +'" /><input class="action_button" type="submit" value="'+ notifySend + '" style="margin-bottom:0px" />';

  if (variant && variant.featured_image && $product.is(":visible") && window.Flickity) {
    var $sliders = $('.product-gallery__main', $product);
    $sliders.each(function() {
      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);
      if ($slider.is(":visible") && $sliderInstance != undefined ) {
        var index = Number($('[data-image-id="' + variant.featured_image.id + '"]').data('index'));
        if (isFinite(index) && index >= 0 && $sliderInstance.cells && index < $sliderInstance.cells.length) {
          $sliderInstance.select(index, false, true);
        }
      }
    });
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function(v){
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }
    $('.sku span', $product).text(variant.sku);
  }

  if (variant && variant.available == true) {
    if(variant.price < variant.compare_at_price){
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
      $('.current_price', $product).parent().addClass('sale');
    } else {
      $('.was_price', $product).html('')
      $('.current_price', $product).parent().removeClass('sale');
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      
      
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');

    if (variant.price > 0) {
      $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
    } else {
      $('.current_price', $product).html("Free");
    }

    $('.modal_price', $product).removeClass('modal_price--sold-out')
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
    $('.current_price').show();
    $('.was_price').show();
    $notify_form.hide();
    $('.purchase-details__quantity', $product).show();
    $('.atc-btn-container', $product).removeClass('disabled');
  } else {
    var message = variant ? Shopify.translation.product_sold_out : Shopify.translation.product_unavailable;
    $('.purchase-details__quantity', $product).hide();
    $('.modal_price', $product).addClass('modal_price--sold-out')
    $('.was_price', $product).html('');
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.sold_out', $product).text(' - ' + message);
    $('.atc-btn-container', $product).addClass('disabled');
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
    $notify_form.hide();
    $notifyFormInputs.empty();

    if (variant && !variant.available) {
      $('.current_price').show();
      $('.was_price').show();
      if (variant.price > 0) {
        $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
      } else {
        $('.current_price', $product).html("Free");
      }
      if(variant.price < variant.compare_at_price){
        $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
        $('.current_price', $product).parent().addClass('sale');
      } else {
        $('.was_price', $product).html('')
        $('.current_price', $product).parent().removeClass('sale');
      }
      $notify_form.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    } else {
      $('.sold_out', $product).text(message);
      $('.current_price').hide();
      $('.was_price').hide();
    }
  }
  $productForm.removeClass("init");
};

function htmlEncode(value){
  if (value) {
    return $('<div/>').text(value).html();
  } else {
    return '';
  }
}

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2);break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

Shopify.updateOptionsInSelector = function(selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
      break;
    default:
      return;
  }
  var availableOptions = Shopify.optionsMap[key] || [];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').prop('disabled', false).prop('checked', false);
    } else {
      $(this).addClass('soldout').find(':radio').prop('checked', false).prop('disabled', true);
    }
  });
  selector.trigger('change');
};

Shopify.linkOptionSelectors = function(product, parent) {
  Shopify.optionsMap = {};
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
  $(parent + " .single-option-selector:eq(0)")
    .off('change.linkOptionSelectors')
    .on('change.linkOptionSelectors', function() {
    Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  $(parent + " .single-option-selector:eq(1)")
    .off('change.linkOptionSelectors')
    .on('change.linkOptionSelectors', function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};
